import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=4b20eaba&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
import style0 from "./Link.vue?vue&type=style&index=0&id=4b20eaba&prod&lang=scss&scoped=true"
import style1 from "./Link.vue?vue&type=style&index=1&id=4b20eaba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20eaba",
  null
  
)

export default component.exports